module.exports = __webpack_public_path__ + "static/mesh-small-5b32ca6509fb8088b16eb7e7e38cb4a1.svg";